export default "__VITE_ASSET__1XgU9to4__$_?nuxt_component=async&nuxt_component_name=SvgoJoinUsGroup&nuxt_component_export=default__"